import { gql } from '@apollo/client'

export default gql`
  fragment ActiveHRBusinessPartner on ActiveHRBusinessPartnerDTO {
    id
    fromDate
    toDate
    companyId
    companyName
    employee {
      id
      firstName
      lastName
      avatarUrl
      companyName
      buName
    }
  }
`
